export const placeHolder = {
    page: 'coverPictureV2',
    subtitle: '快速生成底图，支持叠加营销海报效果',
    image: 'https://feed-image.baidu.com/0/pic/533030698_1549823988_-56109884.png'
};

export const normalIndustry = [
    '全部行业',
    '房产家居',
    '旅游服务',
    '交通出行',
    '整形美容',
    '教育培训',
    '金融服务',
    '商品交易',
    '医疗服务',
    '生活服务',
    '文娱传媒',
    '商务服务',
    '游戏',
    '软件',
    '网络服务',
    '通信',
    '保健品/药品',
    '直营电商',
    '食品饮料'
];

export const designSizeOptions =  [
    {
        value: '16:9',
        label: '16:9',
        children: [
            {
                value: '1140*640',
                label: '1140*640'
            }, {
                value: '1280*720',
                label: '1280*720'
            }, {
                value: '1600*900',
                label: '1600*900'
            }, {
                value: '1920*1080',
                label: '1920*1080'
            }, {
                value: '960*540',
                label: '960*540'
            }
        ]
    },
    {
        value: '3:4',
        label: '3:4',
        children: [
            {
                value: '750*1000',
                label: '750*1000'
            }
        ]
    }
];
